import type { FunctionComponent } from 'react';

import { CopyContent, Price } from '@kanda-libs/ks-design-library';

import { formatPriceForDisplay } from 'common/helpers';
import Profile from 'components/shared/Profile';

export interface TradeInfoProps {
  tradeType?: string;
  tradeBody?: string;
  tradeBodyNumber?: string;
  avgJobValue?: number;
  avgMonthly?: number;
  warrantyLength?: number;
  useSubs?: string;
  referral?: string;
}

const TradeInfo: FunctionComponent<TradeInfoProps> = function ({
  tradeType = '',
  tradeBody,
  tradeBodyNumber,
  avgJobValue,
  avgMonthly,
  warrantyLength,
  useSubs,
  referral,
}) {
  return (
    <Profile.Section className="pb-4 mb-6">
      <Profile.Property
        label="Trade type"
        value={tradeType.split('_').join(' ')}
      />
      <Profile.Property label="Trade body" value={tradeBody} />
      <Profile.Property label="Trade body num" value={tradeBodyNumber} />
      <Profile.Property label="Avg. job value">
        <CopyContent
          content={formatPriceForDisplay(avgJobValue ? avgJobValue / 100 : 0)}
        >
          <Price
            amount={avgJobValue}
            poundsClassName="text-14-22 text-neutral-700"
            centsClassName="text-14-22 text-neutral-700"
          />
        </CopyContent>
      </Profile.Property>
      <Profile.Property label="Avg. job/month" value={avgMonthly} />
      <Profile.Property
        label="Warranty length"
        value={`${warrantyLength} months`}
      />
      <Profile.Property label="Subcontracts" value={useSubs} />
      <Profile.Property label="Referral code" value={referral} />
    </Profile.Section>
  );
};

export default TradeInfo;
